// @flow @jsx h

import { h } from 'preact'
import { PositionIndicator } from './PositionIndicator'
import { Logo } from './Logo'
import { ButtonGroup } from './ButtonGroup'
import styles from './index.css'
import { Router } from '../lib/Router'
import { PATHS } from '../../constants/'

import type { Questions, Answers } from '../../types'

type Props = {
  questions: Questions,
  answers: Answers,
  path: string,
  questionNumber: number,
  toggleModal: () => void,
  restart: () => void,
  ariaHidden: boolean
}

const { RESULT_VIEW, QUESTION_VIEW, EXPLANATION_VIEW } = PATHS

const Overlay = ({
  questions,
  answers,
  path,
  questionNumber,
  toggleModal,
  restart,
  ariaHidden
}: Props) => {
  return (
    <div class={styles.overlay} aria-hidden={ariaHidden}>
      <Logo />
      <Router path={path} multiple>
        <PositionIndicator
          questionNumber={questionNumber}
          questions={questions}
          answers={answers}
          path={[QUESTION_VIEW, EXPLANATION_VIEW]}
        />
        <ButtonGroup
          path={[RESULT_VIEW]}
          toggleModal={toggleModal}
          restart={restart}
        />
      </Router>
    </div>
  )
}

export { Overlay }



// WEBPACK FOOTER //
// ./src/v1/components/Overlay/index.js